import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Lock, Sparkles, ArrowRight } from 'lucide-react';
import { useSubscription } from '../contexts/SubscriptionContext';

const FEATURE_INFO = {
  sentiment: {
    name: 'Sentiment Analysis',
    description: 'Access market sentiment scores across all asset classes with AI-powered analysis.',
  },
  watchlist: {
    name: 'Watchlist',
    description: 'Track your personal portfolio with live prices and AI-powered briefings.',
  },
  thematic_investing: {
    name: 'Thematic Investing',
    description: 'Explore 14 investment themes with performance tracking and analysis.',
  },
  crypto_intel: {
    name: 'Crypto Intel',
    description: 'Get the Top 10 crypto model scores, macro regime analysis, and daily predictions.',
  },
  news_intel: {
    name: 'Community',
    description: 'Feature coming soon.',
  },
  ai_agents: {
    name: 'AI Agents',
    description: 'AI-powered investment assistants for portfolio optimization and analysis.',
  },
};

const UpgradePrompt = ({ feature }) => {
  const navigate = useNavigate();
  const { tier } = useSubscription();
  const info = FEATURE_INFO[feature] || { name: 'PRO Feature', description: 'This feature requires a PRO subscription.' };

  return (
    <div className="flex items-center justify-center min-h-[60vh] p-4">
      <Card className="max-w-lg w-full border-2 border-orange-200 bg-gradient-to-br from-orange-50 to-yellow-50">
        <CardContent className="pt-12 pb-8 text-center">
          <div className="w-20 h-20 rounded-full bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center mx-auto mb-6">
            <Lock className="w-10 h-10 text-white" />
          </div>

          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            {info.name}
          </h2>
          <p className="text-gray-600 mb-6">
            {info.description}
          </p>

          <div className="bg-white rounded-lg p-4 mb-6 border border-orange-200">
            <div className="flex items-center justify-center space-x-2 mb-2">
              <Sparkles className="w-5 h-5 text-orange-500" />
              <span className="font-semibold text-gray-900">Upgrade to PRO</span>
            </div>
            <p className="text-sm text-gray-600">
              {tier === 'free'
                ? 'Start with a 7-day free trial. No credit card required.'
                : 'Upgrade your plan to access this feature.'}
            </p>
          </div>

          <div className="space-y-3">
            <Button
              onClick={() => navigate('/pricing')}
              className="w-full bg-gradient-to-r from-orange-500 to-orange-600 text-white hover:opacity-90"
            >
              View Plans
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
            <Button
              onClick={() => navigate('/')}
              variant="outline"
              className="w-full"
            >
              Back to Dashboard
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default UpgradePrompt;
